import { AxiosError } from 'axios';
import { POST_GROUP_EXAM_REGISTRATION_RETRIEVE_CANDIDATES } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { CandidateListBase } from './model';
import { PaginatedData } from '../../models/List';
import { ApiPathParam } from '../../models/SearchParamSchema';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PostRetrieveCandidateDetailsRequest {
  q: string;
  applicationUuid: string;
  apiPathParam: ApiPathParam;
}

export interface GroupExamOptionalPaper {
  uuid: string;
  paperNo: string;
}

interface SubjectList {
  subjectName: string;
  subjectCode: string;
  optionalPapers: GroupExamOptionalPaper[];
}

export interface PostRetrieveCandidateDetailsResponse extends CandidateListBase {
  examLevel: string[];
  subjectLists: SubjectList[];
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PaginatedData<PostRetrieveCandidateDetailsResponse>) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostRetrieveCandidateDetails = ({ onSuccess, onError }: Input) => {
  const postRetrieveCandidateDetails = async (payload: PostRetrieveCandidateDetailsRequest) => {
    const res = await axiosClient.post<PaginatedData<PostRetrieveCandidateDetailsResponse>>(
      POST_GROUP_EXAM_REGISTRATION_RETRIEVE_CANDIDATES(
        payload.applicationUuid,
        payload.apiPathParam
      ),
      {
        q: payload.q,
      }
    );
    return res.data;
  };

  return useCustomMutation(postRetrieveCandidateDetails, {
    onSuccess,
    onError,
  });
};
